<template>
  <div>
  <v-toolbar flat color="white">
    <v-toolbar-title>Gastos</v-toolbar-title>
    <v-divider
      class="mx-2"
      inset
      vertical
    ></v-divider>
    <v-spacer></v-spacer>
    <v-btn color="primary" dark class="mb-2" v-on:click="nuevoComprobante()">Ingresar gasto</v-btn>
    <v-dialog v-model="dialog" max-width="1500px">
      <v-card>
        <v-card-title>
          <span class="headline">Gasto</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-layout wrap>
                <v-flex xs12 sm6 lg4 d-flex>
                  <v-text-field label="Serie" v-model="comprobante.gastoSerie" v-bind:readonly="disabledComprobante"></v-text-field>
                </v-flex>
                <v-flex xs12 sm5 lg3 d-flex>
                  <v-text-field label="Número" mask="####################" v-model="comprobante.gastoNumero" :messages="errores.gastoNumero.mensajes" :error="errores.gastoNumero.error" v-bind:readonly="disabledComprobante"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout justify-end wrap>
                <v-flex xs8 sm3 lg3 d-flex>
                  <v-menu
                    ref="menu"
                    :close-on-content-click="false"
                    v-model="menu"
                    :nudge-right="40"
                    :return-value.sync="comprobante.gastoFecha"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="gastoFecha"
                      label="Fecha"
                      prepend-icon="event"
                      @blur="comprobante.gastoFecha = parseDate(gastoFecha)"
                      :messages="errores.gastoFecha.mensajes"
                      :error="errores.gastoFecha.error"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="comprobante.gastoFecha" locale='es-pe' @input="$refs.menu.save(comprobante.gastoFecha)" scrollable v-bind:readonly="disabledComprobante"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-container>
          <v-card>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 d-flex v-for="(detalle, id) in comprobante.gastoDetalles" v-bind:key="id">
                  <v-flex xs12 sm9 d-flex>
                    <v-text-field label="Detalle" v-model="detalle.gastoDescripcion" v-on:keyup="detalle.gastoDescripcion = detalle.gastoDescripcion.toUpperCase();" v-bind:readonly="disabledComprobante"></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm2 offset-xs1 d-flex>
                    <v-text-field label="Monto" v-model="detalle.gastoMonto" v-bind:readonly="disabledComprobante" v-money></v-text-field>
                  </v-flex>
                </v-flex>
              </v-layout>
              <v-btn @click="detalleNuevo"
              absolute
              dark
              fab
              bottom
              right
              small
              color="pink"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-container>
          </v-card>
          <br />
          <v-layout justify-end wrap>
            <v-flex xs2 sm2>
              <v-text-field label="Total" :value="registroTotal" maxlenght=20 :messages="errores.gastoTotal.mensajes" :error="errores.gastoTotal.error" readonly v-money></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click.native="cerrar">Cerrar</v-btn>
          <v-btn color="success" dark @click.native="guardar(comprobante.gastoId)" v-if="!disabledComprobante">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>
  <v-data-table
    :headers="headers"
    :items="datos.data"
    :pagination.sync="pagination"
    :total-items="totalComprobantes"
    :loading="loading"
    rows-per-page-text="Filas por página"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.fila[1] }}</td>
      <td class="">{{ props.item.fila[2] }}</td>
      <td class="">{{ props.item.fila[3] }}</td>
      <td class="">{{ props.item.fila[4] }}</td>
      <td class="justify-center layout px-0">
        <v-icon
          small
          class="mr-2"
          @click="verComprobante(props.item)"
        >
          open_in_browser
        </v-icon>
      </td>
    </template>
    <template slot="no-data">
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  data: () => ({
    dialog: false,
    disabledComprobante: false,
    totalComprobantes: 0,
    loading: false,
    pagination: {},
    menu: false,
    gastoFecha: null,
    headers: [
      {
        text: 'Fecha',
        align: 'left',
        value: 0
      },
      { text: 'Serie', value: 1 },
      { text: 'Número', value: 2 },
      { text: 'Monto', value: 3 },
      { text: 'Actions', align: 'center', value: '', sortable: false }
    ],
    datos: [],
    tiposDocumentos: [
      { id: '0', value: '' },
      { id: '1', value: 'DNI' },
      { id: '6', value: 'RUC' },
      { id: '4', value: 'Carnet de extranjería' },
      { id: '7', value: 'Pasaporte' }
    ],
    comprobante: {},
    errores: {
      'gastoFecha': {mensajes: [], error: false},
      'gastoNumero': {mensajes: [], error: false},
      'gastoSerie': {mensajes: [], error: false},
      'gastoTotal': {mensajes: [], error: false}
    }
  }),
  computed: {
    computedGastoFecha () {
      return this.formatoFecha(this.comprobante.gastoFecha)
    },
    registroTotal () {
      var total = 0
      for (var detalle in this.comprobante.gastoDetalles) {
        total += parseFloat(this.comprobante.gastoDetalles[detalle].gastoMonto)
      }
      return total.toFixed(2)
    }
  },
  watch: {
    dialog (val) {
      val || this.cerrar()
    },
    'comprobante.gastoFecha' (val) {
      this.gastoFecha = this.formatoFecha(this.comprobante.gastoFecha)
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaComprobantes(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize()
    this.pagination.rowsPerPage = 10
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaComprobantes (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      solicitudApi.datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      }
      const myRequest = new Request(`${process.env.NODE_API}gasto/listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.datos = datos.d
            this.totalComprobantes = this.datos.registros
            if (parseInt(this.datos.pagina) !== parseInt(this.pagination.page)) {
              this.pagination.page = parseInt(this.datos.pagina)
            }
            this.loading = false
          }
        })
    },
    verComprobante (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = []
      const myRequest = new Request(`${process.env.NODE_API}gasto/ver/id/` + item.id, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.comprobante = datos.d.gasto
            this.errores = datos.d.errores
            if (item.id !== 0) {
              this.disabledComprobante = true
            } else {
              this.disabledComprobante = false
            }
            this.dialog = true
          }
        })
    },
    nuevoComprobante () {
      this.verComprobante({id: 0})
    },
    detalleNuevo () {
      var id = 0
      while (id in this.comprobante.gastoDetalles) {
        id++
      }
      this.comprobante.gastoDetalles[id] = {id: 0, gastoDescripcion: '', gastoMonto: ''}
      this.$forceUpdate()
    },
    cerrar () {
      this.dialog = false
      setTimeout(() => {
      }, 300)
    },
    guardar (id) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.comprobante
      const myRequest = new Request(`${process.env.NODE_API}gasto/guardar/id/` + id, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.verComprobante(datos.d)
              let descendente = 0
              if (this.pagination.descending) {
                descendente = 1
              }
              this.apiListaComprobantes(this.pagination.sortBy, descendente, this.pagination.page)
              this.cerrar()
            } else {
              this.errores = datos.d.errores
            }
          }
        })
    }
  }
}
</script>

<style>
.v-btn--floating .v-icon {
    height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Compras.vue